import { NavLink, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useContext, useEffect, useState } from 'react';
import { getSessionTimeout, getUserInfo } from '../../../services/login/loginService';
import UserContext from '../../../context/user-context';
import styles from './UserPanel.module.css';
import APIError from '../../../services/APIError';
import LanguagePicker from '../Sidebar/LanguagePicker';

function UserPanel() {
  const { t } = useTranslation();
  const userCtx = useContext(UserContext);
  const navigation = useNavigate();
  // set default 30 minutes if timeout not provided
  const [sessionTimeout, setSessionTimeout] = useState(1000 * 60 * 30);


  useEffect(() => {
    const getTimeout = async () => {
      try {
        const timeout = await getSessionTimeout();
        setSessionTimeout(timeout);
      } catch (err) {
        if (err instanceof APIError) {
          console.log(`Failed to retrieve session timeout: ${err.message}`);
        } else {
          console.log(err);
        }
      }
    };
    getTimeout();
  }, []);

  useEffect(() => {
    const getUser = async () => {
      try {
        const userInfo = await getUserInfo();

        userCtx.setUser(userInfo);
        userCtx.setIsLoggedIn(true);
      } catch (err) {
        if (err instanceof APIError) {
          if (err.status === 403) {
            if (sessionStorage.getItem('isDenied') === 'true') {
              navigation('/denied');
            } else {
              sessionStorage.setItem('isDenied', 'true');
            }
          }
          console.log(`Failed to retrieve user info: ${err.message}`);
        } else {
          console.log(err);
        }
        userCtx.setUser(undefined);
        userCtx.setIsLoggedIn(false);
      }
    };
    getUser();
  }, [userCtx.isLoggedIn]);

  useEffect(() => {
    const timer = setTimeout(() => userCtx.setIsLoggedIn(false), sessionTimeout + 5);
    return () => {
      clearTimeout(timer);
    };
  }, [sessionTimeout]);

  return (
    <div className={styles.welcomeMessage}>
      {userCtx.isLoggedIn &&
        <div className={styles.welcome}>{t('header.welcome', { name: userCtx.user.name })}</div>}
      <LanguagePicker />
      {!userCtx.isLoggedIn && (
        <NavLink to='/login' className={styles.login}>
          {t('header.login')}
        </NavLink>
      )}
    </div>
  );
}

export default UserPanel;
